import { createSlice } from '@reduxjs/toolkit';

export const dataMonthSlice = createSlice({
    name: 'dataMonth',
    initialState: {
        dataStart: null,
        dataEnd: null,
        data: null,
        kwhAvgMese: null,
        kwhMaxMese: null,
        spesaMaxMese: null,
        spesaAvgMese: null,
        dataMin: null,
        fasce: null,
        priceKwhAvgMonth: null,
    },
    reducers: {
        setData: (state, action) => {
            state.data = action.payload
        },
        setDataStart: (state, action) => {
            state.dataStart = action.payload
        },
        setDataEnd: (state, action) => {
            state.dataEnd = action.payload
        },
        setKwhAvg: (state, action) => {
            state.kwhAvgMese = action.payload
        },
        setKwhMax: (state, action) => {
            state.kwhMaxMese = action.payload
        },
        setSpesaAvg: (state, action) => {
            state.spesaAvgMese = action.payload
        },
        setSpesaMax: (state, action) => {
            state.spesaMaxMese = action.payload
        },
        setDataMin: (state, action) => {
            state.dataMin = action.payload
        },
        setFasce: (state, action) => {
            state.fasce = action.payload
        },
        setPriceKwhAvgMonth: (state, action) => {
            state.priceKwhAvgMonth = action.payload
        }
    }
});
export const {setPriceKwhAvgMonth, setFasce, setData, setDataStart,setDataEnd,setKwhAvg,setKwhMax, setDataMin, setSpesaAvg, setSpesaMax} = dataMonthSlice.actions;
export default dataMonthSlice.reducer;